import {PARTNERS_TYPES} from './typesMessages';

export const QUESTIONS_PARTNERS = [
  {
    idQuestion: 1,
    fromPartner: 'Qual o nome completo dele(a)?',
    fromOwner: 'Qual seu nome completo?',
    fromEmptyPartner: 'Qual o nome completo dele(a)?',
    fromEmptyPartnerHasName: false,
    type: 'message-receive',
    responseTypeChange: PARTNERS_TYPES.PARTNERS_NAME
    // New mode...
    // responseFlowChange: PARTNERS_TYPES.PARTNERS_NAME,
    // responseTypeChange: PARTNERS_TYPES.PARTNERS_FLOW
  },
  {
    idQuestion: 2,
    fromPartner: 'Qual a data de nascimento de ',
    fromOwner: 'Qual sua data de nascimento?',
    fromEmptyPartner: 'Qual a data de nascimento de ',
    fromEmptyPartnerHasName: true,
    type: 'message-receive',
    responseTypeChange: PARTNERS_TYPES.PARTNERS_BIRTH
    // New mode...
    // responseFlowChange: PARTNERS_TYPES.PARTNERS_BIRTH,
    // responseTypeChange: PARTNERS_TYPES.PARTNERS_FLOW
  },
  {
    idQuestion: 3,
    fromPartner: 'Qual Telefone de ',
    fromOwner: 'Qual seu Telefone?',
    fromEmptyPartner:
      'Você pode me informar o telefone com o DDD desta pessoa para que possamos contatá-la?',
    fromEmptyPartnerHasName: false,
    type: 'message-receive',
    responseTypeChange: PARTNERS_TYPES.PARTNERS_PHONE
    // New mode...
    // responseFlowChange: PARTNERS_TYPES.PARTNERS_PHONE,
    // responseTypeChange: PARTNERS_TYPES.PARTNERS_FLOW
  },
  {
    idQuestion: 4,
    fromPartner: 'Qual é o e-mail de ',
    fromOwner: 'Qual o seu e-mail?',
    fromEmptyPartner: 'E o melhor e-mail para falarmos com ela?',
    fromEmptyPartnerHasName: false,
    type: 'message-receive',
    responseTypeChange: PARTNERS_TYPES.PARTNERS_EMAIL
    // New mode...
    // responseFlowChange: PARTNERS_TYPES.PARTNERS_EMAIL,
    // responseTypeChange: PARTNERS_TYPES.PARTNERS_FLOW
  },
  {
    idQuestion: 5,
    fromPartner: 'Qual é o CPF de ',
    fromOwner: 'Qual o seu CPF?',
    fromEmptyPartner: 'Agora me responda qual o número do CPF de ',
    fromEmptyPartnerHasName: true,
    type: 'message-receive',
    responseTypeChange: PARTNERS_TYPES.PARTNERS_CPF
    // New mode...
    // responseFlowChange: PARTNERS_TYPES.PARTNERS_CPF,
    // responseTypeChange: PARTNERS_TYPES.PARTNERS_FLOW
  }
];
